var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Spinner, Table } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from 'hooks/useNotifications';
import MoveFlowModal from './modals/moveFlowModal';
import RemoveFlowModal from './modals/removeFlowModal';
import RenameFlowModal from './modals/renameFlowModal';
import styles from './numberTableFlows.module.scss';
import NumberTableFlowsDropdown from './numberTableFlowsDropdown';
const NumberTableFlows = ({ number, flows, handleFlowFetch }) => {
    const [isItemRequestSent, setIsItemRequestSent] = useState(false);
    const [isRemoveModalOpen, setIsRemoveModalOpen] = useState(false);
    const [isMoveModalOpen, setIsMoveModalOpen] = useState(false);
    const [isRenameModalOpen, setIsRenameModalOpen] = useState(false);
    const [selectedFlow, setSelectedFlow] = useState(null);
    const navigate = useNavigate();
    const notify = useNotifications();
    const { items, getItemsAsyncStatus } = flows;
    const isLoading = getItemsAsyncStatus === 'loading';
    const isEmptyNumber = items.length === 0 &&
        isItemRequestSent &&
        getItemsAsyncStatus === 'succeeded';
    useEffect(() => {
        if (!isItemRequestSent) {
            handleFlowFetch();
            setIsItemRequestSent(true);
        }
    }, [items, isItemRequestSent, setIsItemRequestSent, handleFlowFetch]);
    const onRenameClose = useCallback(() => {
        setSelectedFlow(null);
        setIsRenameModalOpen(false);
    }, [setSelectedFlow, setIsRenameModalOpen]);
    const onMoveClose = useCallback(() => {
        setSelectedFlow(null);
        setIsMoveModalOpen(false);
    }, [setSelectedFlow, setIsMoveModalOpen]);
    const onRemoveClose = useCallback(() => {
        setSelectedFlow(null);
        setIsRemoveModalOpen(false);
    }, [setSelectedFlow, setIsRemoveModalOpen]);
    const redirectToFlow = (id) => navigate(`/settings/phone/flow/${id}`);
    const redirectToAuditLog = (id) => navigate(`/settings/phone/flow/${id}/history`);
    const duplicateFlow = (flow) => __awaiter(void 0, void 0, void 0, function* () {
        const { id, name: originalName } = flow, originalFlow = __rest(flow, ["id", "name"]);
        const name = `${originalName} (copy)`;
        try {
            const { data: { id }, } = yield flows.create(Object.assign(Object.assign({}, originalFlow), { name, active: false }));
            redirectToFlow(id);
            notify({
                title: 'Flow copied',
                text: `Flow was succesfully copied as "${name}"`,
                className: 'success',
                time: 5000,
                icon: 'done',
            });
        }
        catch (_a) {
            notify({
                title: 'An error occurred',
                text: `An error occurred when trying to copy the "${originalName}" flow`,
                icon: 'exclamation',
                className: 'danger',
            });
        }
    });
    const renderLoadingStatus = () => {
        if (isLoading) {
            return _jsx(Spinner, {});
        }
        if (isEmptyNumber) {
            return _jsx("span", { children: "There are no flows for this number" });
        }
        return null;
    };
    const isLoadingStatusShown = isLoading || isEmptyNumber;
    return (_jsxs(_Fragment, { children: [_jsx(Table, Object.assign({ headerWithBackground: false, framed: false }, { children: _jsxs(Table.Tbody, { children: [isLoadingStatusShown && (_jsx(Table.Tr, { children: _jsx(Table.Td, Object.assign({ className: styles.loading }, { children: renderLoadingStatus() })) })), items.map((flow) => {
                            const { name, id, active } = flow;
                            const onEdit = () => redirectToFlow(id);
                            const onAudit = () => redirectToAuditLog(id);
                            const onDuplicate = () => duplicateFlow(flow);
                            const onRename = () => {
                                setSelectedFlow(flow);
                                setIsRenameModalOpen(true);
                            };
                            const onMove = () => {
                                setSelectedFlow(flow);
                                setIsMoveModalOpen(true);
                            };
                            const onRemove = () => {
                                setSelectedFlow(flow);
                                setIsRemoveModalOpen(true);
                            };
                            return (_jsxs(Table.Tr, { children: [_jsx(Table.Td, Object.assign({ className: classnames(styles.name, {
                                            [styles.nameIsActive]: active,
                                        }) }, { children: _jsx("span", { children: name }) })), _jsx(Table.Td, Object.assign({ className: styles.dropdownWrapper }, { children: _jsx(NumberTableFlowsDropdown, { onEdit: onEdit, onRename: onRename, onDuplicate: onDuplicate, onAudit: onAudit, onMove: onMove, onRemove: onRemove, isActive: active }) }))] }, id));
                        })] }) })), _jsx(RemoveFlowModal, { isShown: isRemoveModalOpen, onClose: onRemoveClose, selectedFlow: selectedFlow, flows: flows }), _jsx(RenameFlowModal, { isShown: isRenameModalOpen, onClose: onRenameClose, selectedFlow: selectedFlow, number: number, flows: flows }), _jsx(MoveFlowModal, { isShown: isMoveModalOpen, number: number, selectedFlow: selectedFlow, flows: flows, onClose: onMoveClose })] }));
};
export default NumberTableFlows;
